export default __webpack_public_path__ + "static/media/userSubscriptionsImg.0f48f480.svg";